import React from "react";

interface ServiceItemCardProps {
  item: any;
  handleItemClick: (id: number) => void;
  businessPage: (bizCode: string) => void;
  handleMapModal: (lat: any, lng: any, address: string) => void;
  onBook: (item: any, mode: "scheduled" | "instant") => void;
}

const ServiceItemCard: React.FC<ServiceItemCardProps> = ({
  item,
  handleItemClick,
  businessPage,
  handleMapModal,
  onBook,
}) => {
  return (
    <div className="col-xl-4 col-lg-4 col-md-6 d-flex align-items-stretch mb-4">
      <div className="item-box w-100">
        <img
          src={item?.default_image || "assets/img/saloon-2.jpg"}
          className="img-fluid img-thumbnail item-img pointer"
          alt={item.title}
          onClick={() => handleItemClick(item.id)}
        />

        <div className="title-info-box">
          <h5 className="item-title pointer" onClick={() => handleItemClick(item.id)}>
            {item.title}
          </h5>
          <small className="title-info">
            -{" "}
            <span
              className="pointer text-link text-primary"
              onClick={() => businessPage(item?.business?.biz_code)}
            >
              {item.business?.name}
            </span>
          </small>
        </div>

        <div className="row">
          <div className="col-7 mb-1">
            <div className="item-info text-secondary fw-500">
              <div className="mb-1">
                <b className="fs-120 text-primary">৳</b>{" "}
                <span className="fw-500">{item.price} BDT</span>
              </div>
              <div className="mb-1">
                <i className="bi bi-clock-fill text-success"></i>{" "}
                <span className="fw-500">{item.duration}</span>
              </div>
              <div className="mb-1">
                <i className="bi bi-geo-alt-fill map-marker-bg"></i>{" "}
                <small className="fw-500">{item?.business?.address}</small>
              </div>
            </div>
          </div>

          <div className="col-5 mb-1 text-center">
            <div className="item-map pointer">
              <img
                src={item.business?.map_image_path}
                alt={item?.business?.name}
                className="img-fluid"
                title="view map"
                onClick={() =>
                  handleMapModal(
                    item.business?.latitude,
                    item.business?.longitude,
                    item.business?.address
                  )
                }
              />
            </div>
          </div>

          <div className="col-12 btn-group">
            <button
              className="btn btn-outline-primary btn-lg w-100"
              onClick={() => onBook(item, "scheduled")}
            >
              📅 <b>Book Now</b>
            </button>
            <button
              className="btn btn-outline-primary btn-lg w-100"
              onClick={() => onBook(item, "instant")}
            >
              🔥 <b>Instant Service</b>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceItemCard;